import type { Class } from '../types/class';

/** Kids per educator (1:N). */
export type StaffChildRatio = 5 | 8 | 10;

export const DEFAULT_STAFF_CHILD_RATIO: StaffChildRatio = 8;

export const MAX_SHIFT_WORKED_MINUTES = 8.5 * 60;

export const OPENING_CLOSING_REQUIRED_COUNT = 2;
export const OPENING_CLOSING_REQUIRED_QUALIFIED = 1;

export function displayClassName(cls: Pick<Class, 'name' | 'groupCode'>): string {
  return cls.groupCode ? `${cls.groupCode} — ${cls.name}` : cls.name;
}

export function educatorsNeededForClass(
  cls: Pick<Class, 'capacity' | 'currentSize' | 'staffChildRatio'>
): number {
  const ratio = cls.staffChildRatio ?? DEFAULT_STAFF_CHILD_RATIO;
  const kids = cls.currentSize > 0 ? cls.currentSize : cls.capacity;
  if (kids <= 0 || ratio <= 0) return 0;
  return Math.ceil(kids / ratio);
}

/** Legacy hardcoded demo / foundation ids — stripped on schema upgrade. */
export const LEGACY_SEEDED_CLASS_IDS = new Set([
  'class-1',
  'class-a',
  'class-b',
  'class-c',
  'class-d',
  'class-e',
  'class-f',
]);

/** Remove auto-seeded demo classes; keep anything created via Class Management UI. */
export function stripLegacySeededClasses(classes: Class[]): Class[] {
  return classes
    .filter((c) => !LEGACY_SEEDED_CLASS_IDS.has(c.id))
    .map((c) => ({
      ...c,
      staffChildRatio: c.staffChildRatio ?? DEFAULT_STAFF_CHILD_RATIO,
      currentSize: c.studentIds?.length ?? c.currentSize ?? 0,
    }));
}
